<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
    :footer="false"
  >
    <form class="t-walkthrough-ivr-user-group__form" @submit.prevent="handleSubmitForm">
      <div class="t-walkthrough-ivr-user-group__description">
        <a-heading tag="h3" size="small">着信グループ設定</a-heading>
        <a-text>着信した際に対応するユーザーをグルーピングして設定します。</a-text>
      </div>
      <div class="t-walkthrough-ivr-user-group__fields">
        <m-form-input label="着信グループ名">
          <a-text-field v-model="formData.group_name" type="text" placeholder="問合せ対応" />
        </m-form-input>
        <m-form-input>
          <m-user-selection-table v-model="formData.users" :user-list="userList" :compact="true" />
        </m-form-input>
        <a-caption-list class="t-walkthrough-ivr-user-group__remark">
          <li>一斉着信は最大10名まで指定できます</li>
          <li>着信フローを利用して分岐を設定すると、別の着信グループを設定できます</li>
        </a-caption-list>
      </div>
      <div class="t-walkthrough-ivr-user-group__buttons">
        <m-button-container>
          <a-button variant="block" submit="submit" color="primary">次へ</a-button>
          <a-button v-if="!backDisable" variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
          <a-button color="primary" class="t-walkthrough-ivr-user-group__button-optional" @click="handleNotSettingClick"
            >初期設定はせずにホーム画面へ</a-button
          >
        </m-button-container>
      </div>
      <teleport to="body">
        <o-modal
          id="walkthroughIvrUser_resultModal"
          v-model:visible="resultModalVisible"
          class="o-modal-remove-phone-number-confirmation"
          footer-variant="confirmation"
          width="442px"
          :footer-shadow="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
        >
          <template #title>{{ resultModalTitle }}</template>
          <a-text>
            <!-- eslint-disable -->
            <span v-html="resultModalContent" />
            <!-- eslint-enable -->
          </a-text>
          <template #footer>
            <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
          </template>
        </o-modal>
      </teleport>
    </form>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import AHeading from '@/components/atoms/heading';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import AText from '@/components/atoms/text';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import MUserSelectionTable from '@/components/molecules/user-selection-table';
import ACaptionList from '@/components/atoms/caption-list';
import { cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';

import { chkTrialCompanyID } from '@/libs/utils';

export default {
  name: 't-walkthrough-ivr-user-group',
  components: {
    TDefaultEntrySidebar,
    AHeading,
    AButton,
    MButtonContainer,
    AText,
    MFormInput,
    ATextField,
    MUserSelectionTable,
    ACaptionList,
  },
  mixins: [customRequest, messageContent, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // userList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // handleFormSubmit: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleNotSettingClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      formData: {
        group_name: '',
        users: [],
        clientNames: [],
      },
      sidebarInfo: {
        sidebarList: [
          { label: 'ユーザー招待' },
          {
            label: '営業時間設定',
            subStepLabel: '営業時間設定する場合',
            steps: ['営業時間設定', '対応方法設定'],
          },
          {
            label: '着信フローの設定',
            subStepLabel: '分岐を設定しない場合',
            steps: ['着信グループ設定'],
            currentStep: 1,
            highlightSubStepCurrent: true,
            showSubStepNumber: false,
          },
        ],
        sidebarCurrent: 3,
        heading: '着信フローの設定',
        subHeading: 'Step 3',
        sidebarSubHeading: 'Walk Through',
        sidebarHeading: '初期設定',
      },
      userList: [],
      companyID: this.$store.state.user.companyID,
      backDisable: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-walkthrough-ivr-user-group');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    this.loadUsers();
    // #3274 For Trial
    if (chkTrialCompanyID(this.companyID)) {
      this.backDisable = true;
    }
  },
  methods: {
    handleSubmitForm(e) {
      e.preventDefault();
      this.addClientName();
      const payload = cloneDeep(this.formData);
      if (this.validateForm(payload)) {
        this.handleFormSubmit(payload);
      }
    },
    addClientName() {
      const clientNames = [];
      for (const id of this.formData.users) {
        clientNames.push(this.userList[id].clientName);
      }
      this.formData.clientNames = clientNames;
    },
    validateForm(formData) {
      // Validate group_name
      if (!formData.group_name) {
        this.showErrorModal(messageContent.requireInput('着信グループ名'));
        return false;
      }
      // Only space check
      const onlySpaceChk = this.onlySpaceCheck(formData.group_name, '着信グループ名');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return false;
      }
      if (formData.group_name && this.hasSpecialCharacterInObject(formData.group_name)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return false;
      }
      const lengthCheck = this.incomingGroupNameLengthCheck(formData.group_name);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return false;
      }
      // Validate users
      if (formData.users.length === 0) {
        this.showErrorModal(messageContent.requireChoice('ユーザー'));
        return false;
      }
      if (formData.users.length > 10) {
        this.showErrorModal(messageContent.exceedMaxUserPerGroup);
        return false;
      }

      return true;
    },
    handleFormSubmit(formData) {
      //console.log('着信グループ設定');
      // console.log(formData);
      this.postRequest('/walkthrough/no-ivr-save', {
        companyID: this.companyID,
        formData: formData,
      })
        .then(res => {
          if (res.status === 'success') {
            this.$router.push({ name: 'WTComplete' });
          } else {
            this.showErrorModal(res.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
      // this.$router.push({ name: 'WTComplete' });
    },
    handleCancelClick() {
      this.$router.push({ name: 'WTSelectIvr' });
    },
    handleNotSettingClick() {
      this.updateFirstVisitFlag();
      this.$router.push({ name: 'Home' });
    },
    updateFirstVisitFlag(status = false) {
      this.postRequest('/walkthrough/update-firstVisitFlag', { status })
        .then(res => {
          if (res.status === 'success') {
            //console.log('firstVisitFlag is updated to', status);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    loadUsers() {
      this.postRequest('/walkthrough/user-list', {
        companyID: this.companyID,
      })
        .then(res => {
          this.userList = res.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
